export default class Model {
  static primaryKey: string = 'id'
  static _cache: {[key: number]: Model}

  static get cache() {
    if (!this._cache) this._cache = {}
    return this._cache
  }

  get klass() {
    return this.constructor as typeof Model
  }

  get primaryKey() {
    const primaryKeyProp = this.klass.primaryKey
    return this[primaryKeyProp]
  }

  set(values: Object): this {
    Object.assign(this, values)
    if (this.primaryKey) this.saveToCache()

    return this
  }

  saveToCache() {
    this.klass.cache[this.primaryKey] = this
  }

  static safeCache<T extends Model>(primaryKey: number): T {
    return (this.cache[primaryKey] || new this()) as T
  }

  static newArray(data: any[]) {
    return data.map(item => new this().set(item))
  }

  belongsTo<J extends Model>(model: typeof Model, primaryKey: number): J {
    return model.cache[primaryKey] as J
  }
}
